import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import Table from '../Table';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import IconWrapper from 'App/common/styles/IconWrapper';

const ACTION_COLUMN_WIDTH = 120;

const AvailableActionCell = ({ row, column }) => {
    return (
        <span
            onClick={() => column.onActionClick(row?.original, 'selected')}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') column.onActionClick(row?.original, 'selected');
            }}
            role="button"
            tabIndex={0}
        >
            <IconWrapper>
                <FaAngleRight />
            </IconWrapper>
        </span>
    );
};

AvailableActionCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({}),
    }).isRequired,
    column: PropTypes.shape({
        onActionClick: PropTypes.func.isRequired,
    }).isRequired,
};

const SelectedActionCell = ({ row, column }) => {
    return (
        <span
            onClick={() => column.onActionClick(row?.original, 'available')}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') column.onActionClick(row?.original, 'available');
            }}
            role="button"
            tabIndex={0}
        >
            <IconWrapper>
                <FaAngleLeft />
            </IconWrapper>
        </span>
    );
};

SelectedActionCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({}),
    }).isRequired,
    column: PropTypes.shape({
        onActionClick: PropTypes.func.isRequired,
    }).isRequired,
};

const defaultSortState = { sortBy: [{ id: 'name', desc: false }] };
const PublisherTable = ({ tableName, availableRecords, selectedRecords, onActionClick, isLoading }) => {
    const columnsForAvailableTable = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Actions',
                id: 'actions',
                onActionClick,
                width: ACTION_COLUMN_WIDTH,
                minWidth: ACTION_COLUMN_WIDTH,
                maxWidth: ACTION_COLUMN_WIDTH,
                style: { width: `${ACTION_COLUMN_WIDTH}px` },
                Cell: AvailableActionCell,
            },
        ],
        [onActionClick]
    );

    const columnsForSelectedTable = useMemo(
        () => [
            {
                Header: 'Name',
                accessor: 'name',
            },
            {
                Header: 'Actions',
                id: 'actions',
                onActionClick,
                width: ACTION_COLUMN_WIDTH,
                minWidth: ACTION_COLUMN_WIDTH,
                maxWidth: ACTION_COLUMN_WIDTH,
                style: { width: `${ACTION_COLUMN_WIDTH}px` },
                Cell: SelectedActionCell,
            },
        ],
        [onActionClick]
    );

    return (
        <Row>
            <Col md={6}>
                <h3 className="mb-2">{`${tableName} Available`}</h3>
                <Table
                    columns={columnsForAvailableTable}
                    data={availableRecords}
                    initialState={defaultSortState}
                    isLoading={isLoading}
                />
            </Col>
            <Col md={6}>
                <h3 className="mb-2">
                    {`${tableName} Selected `}
                    <span style={{ color: 'var(--brandDanger)' }}>*</span>
                </h3>
                <Table
                    columns={columnsForSelectedTable}
                    data={selectedRecords}
                    initialState={defaultSortState}
                    isLoading={isLoading}
                />
            </Col>
        </Row>
    );
};

PublisherTable.propTypes = {
    tableName: PropTypes.string.isRequired,
    availableRecords: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedRecords: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onActionClick: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};

PublisherTable.defaultProps = {
    isLoading: false,
};

export default PublisherTable;
